<div class="container mt-5 text-center">
  <h1 class="display-4" [attr.aria-label]="'Error 403' | translate">403</h1>
  <p class="lead">{{ 'Access Denied' | translate }}</p>
  <p>{{ 'You do not have permission to access this page. Please contact your system administrator.' | translate }}</p>
  <a routerLink="/Personal-Dashboard" class="btn btn-primary">{{ 'Return to Dashboard' | translate }}</a>
</div>
